import { Profile, CurrentUserProfile, BusinessProfile } from 'grow.client';

export const isBusinessProfile = (profile: Profile): profile is BusinessProfile => {
    return (profile as BusinessProfile).businessType !== undefined;
}

export const isCurrentUserProfile = (profile: Profile) : profile is CurrentUserProfile => {
    return (profile as CurrentUserProfile).dateOfBirth !== undefined;
}